var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13.7292H2C0.897333 13.7292 0 12.8318 0 11.7292V3.0625C0 1.95983 0.897333 1.0625 2 1.0625H6V2.39583H2C1.632 2.39583 1.33333 2.69517 1.33333 3.0625V11.7292C1.33333 12.0965 1.632 12.3958 2 12.3958H10.6667C11.0347 12.3958 11.3333 12.0965 11.3333 11.7292V7.72917H12.6667V11.7292C12.6667 12.8318 11.7693 13.7292 10.6667 13.7292Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1399 0.59C12.3546 -0.196667 10.9826 -0.196667 10.1973 0.59L4.0666 6.72067L3.08594 10.6447L7.00994 9.66333L13.1399 3.53267C13.9513 2.72133 13.9513 1.40133 13.1399 0.59ZM12.1973 2.59L11.0593 3.728L10.0019 2.67067L11.1399 1.53267C11.4226 1.25 11.9146 1.25 12.1973 1.53267C12.4886 1.824 12.4886 2.29867 12.1973 2.59Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquareIcon);
export default __webpack_public_path__ + "static/media/edit-square-icon.e856ec722b8d7f8024a2650952278eaf.svg";
export { ForwardRef as ReactComponent };